import clsx from "clsx";
import { useState } from "react";

import { useMapStore } from "../../../stores/mapCordinations";
import LinkComponent from "./atoms/LinkComponent";
import ImageComponent from "./atoms/ImageComponent";
import LargeScreenMenus from "./molecules/LargeScreenMenus";
import MobileNavMenus from "./organisms/MobileNavMenus/MobileNavMenus";
import DesktopMenuTemplate from "./templates/DesktopMenuTemplate/DesktopMenuTemplate";
import close from "./../../../assets/close.png";
// images
import logo from "./../../../assets/Navbar/ZOWN-Blue-logo-no-slogan.svg";
import burgerIcon from "./../../../assets/Navbar/burgerIcon.svg";
import rightArrow from "./../../../assets/openInNewTab.svg";

export type MenuNames = "buy" | "sell" | "sell-buy";

interface HeaderProps {
	customClassName?: string;
	showOfferBanner: boolean;
	setShowOfferBanner: (showOfferBanner: boolean) => void;
}

export const Header = ({ customClassName, showOfferBanner, setShowOfferBanner }: HeaderProps) => {
	const { showSlider } = useMapStore();
	const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);
	const [hoveredMenu, setHoveredMenu] = useState<"" | MenuNames>("");

	return (
		<div
			className={clsx(
				"navbar w-full h-[78px] border border-[#F2F2F2] flex flex-col bg-white transition-colors duration-300 text-white fixed top-0",
				customClassName,
				showSlider ? "z-40" : "z-50"
			)}
		>
			{/* Notice Partnership */}
			{showOfferBanner && (
				<div
					id="notice-partnership"
					className="bg-[#354F24] min-h-[56px] w-full items-center text-[#ffffff] font-medium text-[12px] md:text-body relative flex justify-start md:justify-center py-[15.7px] px-[19px] md:py-0 md:px-0"
				>
					<span className="text-left max-w-[90%] font-light">
						<span className="font-semibold">🎉 Limited Time Offer:</span> Book a call with us today and get an additional
						33% in upfront down payment!*
					</span>
					<button
						id="notice-partnership__button"
						onClick={() => {
							setShowOfferBanner(false);
						}}
						className="transparent h-4 w-4 absolute top-[50%] md:right-[10.47px] right-[16.5px] translate-y-[-50%]"
					>
						<img height="100%" width="100%" src={close} alt="close-icon" />
					</button>
				</div>
			)}

			{/* Main Header */}
			<header className="relative bg-white md:border-b-[1px] w-full">
				<nav
					className="flex items-center justify-between p-6 md:px-[24px] md:py-[18px] mx-auto text-[13.5px]"
					aria-label="Global"
				>
					<div className="flex mr-6">
						<LinkComponent to="https://www.zown.ca/" className="-m-1.5 p-1.5 hidden lg:block">
							<span className="sr-only">Zown CA</span>
							<ImageComponent width="128px" height="54px" source={logo} alt="zown-logo" />
						</LinkComponent>
						<LinkComponent to="https://www.zown.ca/" className="-m-1.5 p-1.5 lg:hidden block">
							<span className="sr-only">Zown CA</span>
							<ImageComponent width="97px" height="33px" source={logo} alt="zown-logo-sm" />
						</LinkComponent>
					</div>
					<LargeScreenMenus
						onHover={(menuName) => {
							setHoveredMenu(menuName);
						}}
					/>
					{/* Desktop Buttons */}
					<div className="hidden lg:flex gap-2 items-center">
						<button
							className="text-black border-2 rounded-full px-6 py-1 text-lg  font-medium border-black"
							onClick={() => (window.location.href = "https://zown.ca/contact-us")}
						>
							Contact Us
						</button>
						<button
							className="text-white border-2 rounded-full bg-[#1a1a1a] font-medium px-6 py-1 gap-2 text-lg items-center justify-center flex border-black"
							onClick={() => (window.location.href = "https://zown.ca/buyer/down-payment-qualification")}
						>
							Get Qualified
							<img src={rightArrow} alt="openInNewTab-icon" />
						</button>
					</div>
					{/* Mobile Menu Button */}
					<button onClick={() => setShowMobileMenu((prevState) => !prevState)} className="flex lg:hidden">
						<ImageComponent source={burgerIcon} alt="burger-menu" width="30px" height="30px" />
					</button>
				</nav>

				{/* Mobile menu */}
				{showMobileMenu ? <MobileNavMenus handleClose={() => setShowMobileMenu(false)} /> : null}

				{/* Desktop menus */}
				{hoveredMenu !== "" ? (
					<DesktopMenuTemplate onMouseLeave={() => setHoveredMenu("")} variant={hoveredMenu} />
				) : null}
			</header>
		</div>
	);
};
